import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { WATERMARK_ANCHORS, type WatermarkAnchor } from '@/lib/campaign-watermark-types';

type Props = {
  value: WatermarkAnchor;
  onChange: (anchor: WatermarkAnchor) => void;
};

export const WatermarkAnchorPicker: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div
      className="grid grid-cols-3 gap-1 w-32 h-32 rounded-md border border-border bg-muted/40 p-1"
      role="radiogroup"
      aria-label={t('admin.campaigns.edit.watermark.anchorLabel')}
    >
      {WATERMARK_ANCHORS.map((anchor) => {
        const selected = value === anchor;
        return (
          <button
            key={anchor}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={t(`admin.campaigns.edit.watermark.anchors.${anchor}`)}
            onClick={() => onChange(anchor)}
            className={cn(
              'rounded-sm flex items-center justify-center transition-colors',
              selected
                ? 'bg-primary text-primary-foreground'
                : 'bg-background hover:bg-accent',
            )}
          >
            <span
              className={cn(
                'block w-2 h-2 rounded-full',
                selected ? 'bg-primary-foreground' : 'bg-muted-foreground/60',
              )}
            />
          </button>
        );
      })}
    </div>
  );
};

export default WatermarkAnchorPicker;
